import React from "react";
import ButtonFunc from "../ButtonFunc";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import Moment from 'moment';
import 'moment/locale/th';
import { useDispatch, useSelector } from "react-redux";
import { getDetailLotteryRound } from "../../features/lotteryInvoice"
const BoxNumber = React.forwardRef((props, ref) => {
  return (
    <input
      id={props.i}
      ref={(el) => (ref.current[props.i] = el)}
      value={props.num}
      onChange={props.onChange}
      maxLength="1"
      className="border border-[#b3853e] rounded-lg shadow text-[#b3853e] shadow-[#b3853e] h-10 w-10 sm:h-10 sm:w-10 md:h-16 md:w-16 text-center text-2xl md:text-4xl focus:outline-none focus:ring-2 focus: ring-[#b3853e]"
      type="tel"
      autoFocus={props.i === 0 && true}
      autoComplete="off"
    />
  );
});

const SearchNumber = (props) => {
  const dispatch = useDispatch(); 
  React.useEffect(() => {
    dispatch(getDetailLotteryRound())
  },[])
  const detailLotteryRoundDate = useSelector((state) => state.invoice.detailLotteryRoundDate);
  return (
    <div className="md:mx-10 h-auto w-auto shadow rounded-lg text-center mt-5 font-bold bg-[#f8eede] py-2">
      <h1 className=" text-lg text-[#b3853e]">งวดวันที่{Moment(detailLotteryRoundDate).locale("th").format('Do MMMM YYYY')}</h1>
      <h2 className="text-sm mb-2">ค้นหาเลขเด็ด</h2>
      <form className="grid grid-cols-6 gap-2 px-5 my-2 md:px-10 place-items-center pb-2">
        {props.Number?.map((num, i) => (
          <BoxNumber
            key={i}
            ref={props.refer}
            i={i}
            Number={props.Number}
            num={num}
            onChange={props.onChange}
          />
        ))}
      </form>
      {/* <HitNumber /> */}
      <div className="grid grid-cols-3 gap-2 mx-2">
        <ButtonFunc
          name="ยกเลิก"
          color="bg-[#ffffff]"
          textColor="text-[#b3853e]"
          rounded={true}
          function={props.clearNumber}
        />
        <ButtonFunc
          name="สุ่มเลข"
          color="bg-[#ffffff]"
          textColor="text-[#b3853e]"
          rounded={true}
          function={props.randomNumber}
        />
        <ButtonFunc
          name="ค้นหา"
          color="bg-[#b3853e]"
          textColor="text-[#f8eede]"
          rounded={true}
          function={props.onSearch}
        />
      </div>
    </div>
  );
};

export default SearchNumber;
